import config from "../config/local";
import OtpInput from "react-otp-input";
import React, { Component, Fragment } from "react";
import NotificationSystem from "react-notification-system";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Navbar,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
} from "reactstrap";

import PageSpinner from "../components/PageSpinner";

import "../styles/login.css";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import * as Server from "../Server";
import bn from "../utils/bemnames";
import DefaultImage from "../assets/img/defaultUser.png";

const bem = bn.create("header");

class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clubId: "",
      clubName: "",
      parentId: "",
      adult: {},
      player: {},
      emailOtp: "",
      phoneOtp: "",
      submitType: "",
      isUpdate: false,
      verifyOtp: false,
      showLoader: false,
      disabledFields: false,
      otpVerificationModal: false,
      registerFormFieldsAdult: [],
      registerFormFieldsPlayers: [],
      wavierFormFieldsAdult: [],
      wavierFormFieldsPlayers: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  componentDidMount() {
    let club = this.props.location.pathname
      .split("/")
      .filter((path) => path !== "");
    this.getRegistrationForm(club[0]);
  }

  updateState = async (type, key, value) => {
    if (value === "on") {
      switch (type) {
        case "adult":
          value = !this.state.adult[key];
          break;
        case "player":
          value = !this.state.player[key];
          break;
        default:
          break;
      }
    }
    if (key === "phone" || key === "playerPhone") {
      if (value.length > 10) {
        return true;
      }
    }
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: value,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: value,
          },
        }));
        break;
      default:
        break;
    }
  };

  getRegistrationForm = async (club) => {
    try {
      this.setState({ showLoader: true });
      let clubId = config.clubs[club];
      if (!clubId) {
        this.setState({
          registerFormFieldsAdult: [],
          registerFormFieldsPlayers: [],
        });
        return;
      }
      let response = await Server.request({
        url: `rushsoccer/registration/form?clubId=${clubId}`,
        method: "GET",
      });
      if (
        response.registrationFormDetails &&
        response.registrationFormDetails.registerForm
      ) {
        let allFields = response.registrationFormDetails.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        let playerFields = allFields.filter(
          (form) =>
            form.for.value === "player" &&
            form._id !== "2e3b1830-6147-4955-a3b3-b8e3a2db3d14"
        );
        let adultFields = allFields
          .filter((form) => form.for.value === "adult")
          .map((field) =>
            field.keyName === "photo"
              ? Object.assign(field, { keyName: "photo1" })
              : field
          );
        let wavierFormFieldsAdult = allFields.filter(
          (form) => form.for.value === "adult" && form.inputType === "waviers"
        );
        let wavierFormFieldsPlayers = allFields.filter(
          (form) => form.for.value === "player" && form.inputType === "waviers"
        );
        this.setState({
          showLoader: false,
          clubId: response.registrationFormDetails._id,
          clubName: response.registrationFormDetails.name,
          registerFormFieldsAdult: adultFields,
          registerFormFieldsPlayers: playerFields,
          wavierFormFieldsAdult,
          wavierFormFieldsPlayers,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!this.state.verifyOtp) {
        this.setState({
          showLoader: true,
          emailOtp: "",
          phoneOtp: "",
        });
        let adultFileFields = this.state.registerFormFieldsAdult.filter(
          (field) => field.inputType === "dropdown"
        );
        let playersFileFields = this.state.registerFormFieldsPlayers.filter(
          (field) => field.inputType === "dropdown"
        );
        for (let index = 0; index < adultFileFields.length; index++) {
          if (adultFileFields[index].required) {
            if (!this.state.adult[adultFileFields[index].keyName]) {
              throw Error(`Select the ${adultFileFields[index].placeholder}`);
            }
          }
        }
        for (let index = 0; index < playersFileFields.length; index++) {
          if (playersFileFields[index].required) {
            if (!this.state.player[playersFileFields[index].keyName]) {
              throw Error(`Select the ${playersFileFields[index].placeholder}`);
            }
          }
        }
        let response = await Server.staticTokenServerRequest(
          {
            url: "rushUser/createOTP",
            method: "POST",
            data: {
              sendOn: "both",
              email: this.state.adult.email,
              phone: `+1${this.state.adult.phone}`,
              username: `1${this.state.adult.phone}`,
            },
          },
          true
        );
        if (response) {
          this.setState({
            verifyOtp: true,
            showLoader: false,
            otpVerificationModal: !this.state.otpVerificationModal,
          });
        }
      } else {
        if (!this.state.isUpdate) {
          if (!this.state.phoneOtp || !this.state.emailOtp) {
            this.notificationSystem.addNotification({
              message: "Enter the OTP",
              level: "error",
            });
            return;
          }
        }
        this.setState({ showLoader: true });
        let formData = new FormData();
        let adultFileFields = this.state.registerFormFieldsAdult
          .filter((field) => field.inputType === "fileupload")
          .map((field) => Object.assign(field, { for: "adult" }));
        let playersFileFields = this.state.registerFormFieldsPlayers
          .filter((field) => field.inputType === "fileupload")
          .map((field) => Object.assign(field, { for: "player" }));
        if (!this.state.isUpdate) {
          for (let index = 0; index < adultFileFields.length; index++) {
            if (adultFileFields[index].required) {
              if (this.state.adult[adultFileFields[index].keyName]) {
                formData.append(
                  [adultFileFields[index].keyName],
                  this.state.adult[adultFileFields[index].keyName]
                );
              } else {
                let blob = this.dataURItoBlob(DefaultImage);
                formData.append(
                  [adultFileFields[index].keyName],
                  blob,
                  "defaultUser.png"
                );
              }
            } else {
              if (this.state.adult[adultFileFields[index].keyName])
                formData.append(
                  [adultFileFields[index].keyName],
                  this.state.adult[adultFileFields[index].keyName]
                );
            }
          }
        }
        for (let index = 0; index < playersFileFields.length; index++) {
          if (playersFileFields[index].required) {
            if (this.state.player[playersFileFields[index].keyName]) {
              formData.append(
                [playersFileFields[index].keyName],
                this.state.player[playersFileFields[index].keyName]
              );
            } else {
              let blob = this.dataURItoBlob(DefaultImage);
              formData.append(
                [playersFileFields[index].keyName],
                blob,
                "defaultUser.png"
              );
            }
          } else {
            if (this.state.player[playersFileFields[index].keyName])
              formData.append(
                [playersFileFields[index].keyName],
                this.state.player[playersFileFields[index].keyName]
              );
          }
        }
        formData.append("emailOtp", this.state.emailOtp);
        formData.append("phoneOtp", this.state.phoneOtp);
        formData.append("clubId", this.state.clubId);
        formData.append("clubName", this.state.clubName);
        formData.append("isUpdate", this.state.isUpdate);
        formData.append("parentId", this.state.parentId);
        formData.append("adult", JSON.stringify(this.state.adult));
        formData.append("player", JSON.stringify(this.state.player));
        let deleteKeys = adultFileFields
          .concat(playersFileFields)
          .map((fields) => ({ keyName: fields.keyName, for: fields.for }));
        if (deleteKeys && deleteKeys.length)
          formData.append("deleteKeys", JSON.stringify(deleteKeys));
        let response = await Server.staticTokenServerRequest(
          {
            url: "rushUser/register",
            method: "POST",
            data: formData,
          },
          false
        );
        if (response) {
          if (response.success) {
            if (!this.state.isUpdate) this.toggleotpVerificationModal();
            this.state.submitType === "submit"
              ? this.setState({
                  verifyOtp: false,
                  adult: {},
                  player: {},
                  phoneOtp: "",
                  emailOtp: "",
                  isUpdate: false,
                  showLoader: false,
                  disabledFields: false,
                  parentId: response.user._id,
                })
              : this.setState({
                  player: {},
                  emailOtp: "",
                  phoneOtp: "",
                  isUpdate: true,
                  showLoader: false,
                  disabledFields: true,
                  parentId: response.user._id,
                });
            this.notificationSystem.addNotification({
              message: response.message,
              level: "success",
            });
          } else {
            this.setState({
              showLoader: false,
            });
            this.notificationSystem.addNotification({
              message: response.message,
              level: "error",
            });
            this.toggleotpVerificationModal();
          }
        }
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  handleChange = async (type, key, event) => {
    const fileUploaded = event.target.files[0];
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      default:
        break;
    }
    event.target.value = null;
  };

  toggleotpVerificationModal = () => {
    this.setState({
      otpVerificationModal: !this.state.otpVerificationModal,
    });
  };

  render() {
    return (
      <Fragment>
        <Navbar
          light
          expand
          className={bem.b("#17517B")}
          style={{
            backgroundColor: "#17517B",
            borderBottom: 0,
            marginBottom: 0,
          }}
        >
          <div
            style={{
              color: "white",
              margin: "auto",
            }}
          >
            <h1
              style={{
                margin: "auto",
                fontWeight: "bold",
              }}
            >
              RushSoccer
            </h1>
          </div>
        </Navbar>
        {this.state.registerFormFieldsAdult.length &&
        this.state.registerFormFieldsPlayers.length ? (
          <Container>
            <PageSpinner showLoader={this.state.showLoader} />
            <div
              className="login-form"
              style={{
                margin: "20px 0px",
                maxWidth: "unset",
              }}
            >
              <Form className="form" onSubmit={this.onSubmit}>
                <Col
                  style={{
                    borderBottom: "3px solid #e4e5e6",
                    marginBottom: "10px",
                  }}
                >
                  <h2>Registration Form</h2>
                </Col>
                <Col
                  style={{
                    textAlign: "center",
                  }}
                >
                  <h3>Register Parent</h3>
                </Col>
                {this.state.registerFormFieldsAdult.map(
                  (registerFormField, index) => (
                    <Col key={index}>
                      <FormGroup>
                        {registerFormField.inputType === "text" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              disabled={this.state.disabledFields}
                              id={index}
                              name={registerFormField.name}
                              type="text"
                              value={
                                this.state.adult[registerFormField.keyName] ||
                                ""
                              }
                              onChange={(event) =>
                                this.updateState(
                                  "adult",
                                  registerFormField.keyName,
                                  event.target.value
                                )
                              }
                              placeholder={registerFormField.placeholder}
                              required={registerFormField.required}
                            />
                          </>
                        )}
                        {registerFormField.inputType === "number" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              id={index}
                              disabled={this.state.disabledFields}
                              name={registerFormField.name}
                              type="number"
                              value={
                                this.state.adult[registerFormField.keyName] ||
                                ""
                              }
                              onChange={(event) =>
                                event.target.value > -1 &&
                                this.updateState(
                                  "adult",
                                  registerFormField.keyName,
                                  event.target.value
                                )
                              }
                              placeholder={registerFormField.placeholder}
                              required={registerFormField.required}
                            />
                          </>
                        )}
                        {registerFormField.inputType === "datepicker" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              id={index}
                              disabled={this.state.disabledFields}
                              name={registerFormField.name}
                              type="date"
                              value={
                                this.state.adult[registerFormField.keyName] ||
                                ""
                              }
                              onChange={(event) =>
                                this.updateState(
                                  "adult",
                                  registerFormField.keyName,
                                  event.target.value
                                )
                              }
                              placeholder={registerFormField.placeholder}
                              required={registerFormField.required}
                            />
                          </>
                        )}
                        {registerFormField.inputType === "dropdown" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              disabled={this.state.disabledFields}
                              type="select"
                              name={registerFormField.name}
                              value={
                                this.state.adult[registerFormField.keyName] ||
                                "default"
                              }
                              required={registerFormField.required}
                              onChange={(event) =>
                                this.updateState(
                                  "adult",
                                  registerFormField.keyName,
                                  event.target.value
                                )
                              }
                            >
                              <option value="default" disabled>
                                Select the value
                              </option>
                              {registerFormField.values.map((value, index) => (
                                <option key={index} value={value}>
                                  {value}
                                </option>
                              ))}
                            </Input>
                          </>
                        )}
                        {/* {registerFormField.inputType === "fileupload" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <div>
                              <Label htmlFor={registerFormField._id}>
                                <span className="btn btn-secondary">
                                  Select File
                                </span>
                                <span style={{ marginLeft: "5px" }}>
                                  {
                                    this.state.adult[
                                    `${registerFormField.keyName}FileName`
                                    ]
                                  }
                                </span>
                              </Label>
                              <input
                                disabled={this.state.disabledFields}
                                style={{ display: "none" }}
                                id={registerFormField._id}
                                type="file"
                                onChange={(event) =>
                                  this.handleChange(
                                    "adult",
                                    registerFormField.keyName,
                                    event
                                  )
                                }
                              />
                            </div>
                          </>
                        )} */}
                      </FormGroup>
                    </Col>
                  )
                )}
                <Col
                  style={{
                    textAlign: "center",
                    padding: "10px 0px",
                    borderTop: "3px solid #e4e5e6",
                  }}
                >
                  <h3>Register Player</h3>
                </Col>
                {this.state.registerFormFieldsPlayers.map(
                  (registerFormField, index) => (
                    <Col key={index}>
                      <FormGroup>
                        {registerFormField.inputType === "text" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              id={index}
                              name={registerFormField.name}
                              type="text"
                              value={
                                this.state.player[registerFormField.keyName] ||
                                ""
                              }
                              onChange={(event) =>
                                this.updateState(
                                  "player",
                                  registerFormField.keyName,
                                  event.target.value
                                )
                              }
                              placeholder={registerFormField.placeholder}
                              required={registerFormField.required}
                            />
                          </>
                        )}
                        {registerFormField.inputType === "number" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              id={index}
                              name={registerFormField.name}
                              type="number"
                              value={
                                this.state.player[registerFormField.keyName] ||
                                ""
                              }
                              onChange={(event) =>
                                event.target.value > -1 &&
                                this.updateState(
                                  "player",
                                  registerFormField.keyName,
                                  event.target.value
                                )
                              }
                              placeholder={registerFormField.placeholder}
                              required={registerFormField.required}
                            />
                          </>
                        )}
                        {registerFormField.inputType === "datepicker" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              id={index}
                              name={registerFormField.name}
                              type="date"
                              value={
                                this.state.player[registerFormField.keyName] ||
                                ""
                              }
                              onChange={(event) =>
                                this.updateState(
                                  "player",
                                  registerFormField.keyName,
                                  event.target.value
                                )
                              }
                              placeholder={registerFormField.placeholder}
                              required={registerFormField.required}
                            />
                          </>
                        )}
                        {registerFormField.inputType === "dropdown" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <Input
                              type="select"
                              name={registerFormField.name}
                              value={
                                this.state.player[registerFormField.keyName] ||
                                "default"
                              }
                              required={registerFormField.required}
                              onChange={(event) =>
                                this.updateState(
                                  "player",
                                  registerFormField.keyName,
                                  event.target.value
                                )
                              }
                            >
                              <option value="default" disabled>
                                Select the value
                              </option>
                              {registerFormField.values.map((value, index) => (
                                <option key={index} value={value}>
                                  {value}
                                </option>
                              ))}
                            </Input>
                          </>
                        )}
                        {/* {registerFormField.inputType === "fileupload" && (
                          <>
                            <Label>{registerFormField.placeholder}</Label>
                            <div>
                              <Label htmlFor={registerFormField._id}>
                                <span className="btn btn-secondary">
                                  Select File
                                </span>
                                <span style={{ marginLeft: "5px" }}>
                                  {
                                    this.state.player[
                                    `${registerFormField.keyName}FileName`
                                    ]
                                  }
                                </span>
                              </Label>
                              <input
                                style={{ display: "none" }}
                                id={registerFormField._id}
                                type="file"
                                onChange={(event) =>
                                  this.handleChange(
                                    "player",
                                    registerFormField.keyName,
                                    event
                                  )
                                }
                              />
                            </div>
                          </>
                        )} */}
                      </FormGroup>
                    </Col>
                  )
                )}
                {this.state.wavierFormFieldsAdult.length ||
                this.state.wavierFormFieldsPlayers.length ? (
                  <>
                    <Col
                      style={{
                        borderTop: "3px solid #e4e5e6",
                        paddingTop: "10px",
                      }}
                    >
                      <h2>Waviers</h2>
                    </Col>
                    {this.state.wavierFormFieldsAdult.length ? (
                      <>
                        <Col
                          style={{
                            textAlign: "center",
                            padding: "10px 0px",
                            borderTop: "3px solid #e4e5e6",
                          }}
                        >
                          <h3>Waviers For Adult</h3>
                        </Col>
                        {this.state.wavierFormFieldsAdult.map(
                          (wavierFormField, index) => (
                            <Col key={index}>
                              <FormGroup>
                                {wavierFormField.inputType === "waviers" && (
                                  <>
                                    <div className="d-flex">
                                      <CustomInput
                                        type="checkbox"
                                        id={wavierFormField._id}
                                        label={wavierFormField.placeholder}
                                        required={wavierFormField.required}
                                        checked={
                                          this.state.adult[
                                            wavierFormField.keyName
                                          ] || false
                                        }
                                        onChange={(event) =>
                                          this.updateState(
                                            "adult",
                                            wavierFormField.keyName,
                                            event.target.value
                                          )
                                        }
                                      />
                                      {wavierFormField.required && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          *
                                        </span>
                                      )}
                                    </div>
                                    <Input
                                      id={index}
                                      type="textarea"
                                      disabled
                                      style={{ height: "160px" }}
                                      value={wavierFormField.value}
                                    />
                                  </>
                                )}
                              </FormGroup>
                            </Col>
                          )
                        )}
                      </>
                    ) : null}
                    {this.state.wavierFormFieldsPlayers.length ? (
                      <>
                        <Col
                          style={{
                            textAlign: "center",
                            padding: "10px 0px",
                            borderTop: "3px solid #e4e5e6",
                          }}
                        >
                          <h3>Waviers For Players</h3>
                        </Col>
                        {this.state.wavierFormFieldsPlayers.map(
                          (wavierFormField, index) => (
                            <Col key={index}>
                              <FormGroup>
                                {wavierFormField.inputType === "waviers" && (
                                  <>
                                    <div className="d-flex">
                                      <CustomInput
                                        type="checkbox"
                                        id={wavierFormField._id}
                                        label={wavierFormField.placeholder}
                                        required={wavierFormField.required}
                                        checked={
                                          this.state.player[
                                            wavierFormField.keyName
                                          ] || false
                                        }
                                        onChange={(event) =>
                                          this.updateState(
                                            "player",
                                            wavierFormField.keyName,
                                            event.target.value
                                          )
                                        }
                                      />
                                      {wavierFormField.required && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          *
                                        </span>
                                      )}
                                    </div>
                                    <Input
                                      id={index}
                                      type="textarea"
                                      disabled
                                      style={{ height: "160px" }}
                                      value={wavierFormField.value}
                                    />
                                  </>
                                )}
                              </FormGroup>
                            </Col>
                          )
                        )}
                      </>
                    ) : null}
                  </>
                ) : null}
                <Col
                  style={{
                    padding: "5px 0px",
                    borderTop: "3px solid #e4e5e6",
                  }}
                ></Col>
                <Col
                  style={{
                    textAlign: "center",
                  }}
                >
                  {this.state.isUpdate ? (
                    <>
                      <Button
                        type="submit"
                        onClick={() =>
                          this.setState({
                            submitType: "submit",
                          })
                        }
                      >
                        Submit
                      </Button>
                      <Button
                        type="submit"
                        className="ml-2"
                        onClick={() =>
                          this.setState({
                            submitType: "addAnotherChild",
                          })
                        }
                      >
                        Save and add another child
                      </Button>
                    </>
                  ) : (
                    <Button
                      type="submit"
                      onClick={() =>
                        this.setState({
                          verifyOtp: false,
                        })
                      }
                    >
                      Verify And Submit
                    </Button>
                  )}
                </Col>
              </Form>
            </div>
            {this.state.otpVerificationModal ? (
              <Modal
                isOpen={this.state.otpVerificationModal}
                toggle={(event) => this.toggleotpVerificationModal()}
                className="modal-md"
              >
                <ModalHeader
                  style={{
                    background: "#f8f9fa",
                  }}
                  toggle={(event) => this.toggleotpVerificationModal()}
                >
                  OTP Verification
                </ModalHeader>
                <ModalBody
                  style={{
                    background: "#f8f9fa",
                  }}
                >
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label>
                          <h2>Enter Email Otp</h2>
                        </Label>
                        <OtpInput
                          inputStyle={{
                            width: "3rem",
                            height: "3rem",
                            margin: "0 1rem",
                            fontSize: "2rem",
                            borderRadius: "4px",
                            border: "1px solid rgba(0,0,0,0.3)",
                          }}
                          value={this.state.emailOtp}
                          onChange={(value) =>
                            this.setState({
                              emailOtp: value,
                            })
                          }
                          numInputs={4}
                          separator={<span>-</span>}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label>
                          <h2>Enter Phone Otp</h2>
                        </Label>
                        <OtpInput
                          className="d-flex justify-content-center"
                          inputStyle={{
                            width: "3rem",
                            height: "3rem",
                            margin: "0 1rem",
                            fontSize: "2rem",
                            borderRadius: "4px",
                            border: "1px solid rgba(0,0,0,0.3)",
                          }}
                          value={this.state.phoneOtp}
                          onChange={(value) =>
                            this.setState({
                              phoneOtp: value,
                            })
                          }
                          numInputs={4}
                          separator={<span>-</span>}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter
                  style={{
                    background: "#f8f9fa",
                  }}
                >
                  <Button onClick={() => this.toggleotpVerificationModal()}>
                    Cancel
                  </Button>{" "}
                  <Form className="form" onSubmit={this.onSubmit}>
                    <Button
                      type="submit"
                      onClick={() =>
                        this.setState({
                          submitType: "submit",
                        })
                      }
                    >
                      Verify and Submit
                    </Button>
                    <Button
                      className="ml-2"
                      type="submit"
                      onClick={() =>
                        this.setState({
                          submitType: "addAnotherChild",
                        })
                      }
                    >
                      Verify and Add Other Child
                    </Button>
                  </Form>
                </ModalFooter>
              </Modal>
            ) : null}
            <NotificationSystem
              dismissible={false}
              ref={(notificationSystem) =>
                (this.notificationSystem = notificationSystem)
              }
              style={NOTIFICATION_SYSTEM_STYLE}
            />
          </Container>
        ) : (
          <Container>
            <div
              className="login-form"
              style={{
                marginTop: "20px",
                maxWidth: "unset",
              }}
            >
              <Col
                style={{
                  textAlign: "center",
                  borderBottom: "3px solid #e4e5e6",
                  marginBottom: "10px",
                }}
              >
                <h2>Registration form not found</h2>
              </Col>
            </div>
          </Container>
        )}
      </Fragment>
    );
  }
}

export default RegistrationForm;
